import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'cms-article-name',
  styleUrl: 'cms-article-name.scss',
  shadow: true,
})
export class CmsArticleName {
  /**
   * Set the name
   */
  @Prop() name: string;

  /**
   * Set the id (optional)
   */
  @Prop() number?: string;

  render() {
    return (
      <Host class='article-name-wrapper'>
        <div class='article-name'>{this.name}</div>
        {this.number != null ? (
          <div class='article-id'>Art. {this.number}</div>
        ) : (
          ''
        )}
      </Host>
    );
  }
}
